import React from "react"

//content
import AppHeader from "./AppHeader";
import AppContent from "./AppContent";

//interfaces
import { IMobileAppPreview } from "../../../interfaces/mobileAppPreview/mobileAppPreview";


const MobileAppPreview = ({appName, appContent}: IMobileAppPreview) => {
    return (
        <div className="mobile-app-preview-container">
            <div className="mock-camera-panel"/>

            <div className="preview-content-wrapper">
                <AppHeader 
                    appName={appName} 
                />

                <AppContent
                    appContent={appContent}
                />
            </div>
        </div>
    )
}

export default MobileAppPreview